import React, { FC } from 'react';
import classnames from 'classnames';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { Hyperlink } from '../../components/Hyperlink';
import styles from './header_logo.module.scss';

type Props = {
  source: string;
  loggedIn: boolean;
};

export const HeaderLogo: FC<Props> = ({ source, children, loggedIn }) => (
  <Hyperlink
    className={classnames(styles.logo, { [styles.logoNotLogged]: !loggedIn })}
    href="/"
    source={source}
    onClick={() => {
      doctrineAnalytics('Nav DoctrineLogoClicked');
    }}
  >
    {children}
  </Hyperlink>
);
